import React from 'react';
import { Card, CardBody, Spinner, Progress } from 'reactstrap';

export const FormLoadingScreen = ({
	message = 'Cargando datos del formulario...',
	submessage = 'Por favor espere mientras cargamos los establecimientos, bodegas y configuración necesaria.',
	progress = null, // Opcional: número entre 0 y 100
}) => {
	return (
		<Card className='border shadow-sm'>
			<CardBody className='p-5 text-center'>
				<div className='mb-4'>
					<Spinner
						color='primary'
						style={{ width: '3rem', height: '3rem' }}
					/>
				</div>

				<h4 className='mb-2'>{message}</h4>
				<p className='text-muted mb-4'>{submessage}</p>

				{progress !== null && (
					<Progress
						value={progress}
						color='primary'
						style={{ height: '8px' }}
						className='mb-2'
					/>
				)}

				<div className='text-muted small'>
					<i className='ri-information-line me-1'></i>
					Esto solo tomará unos segundos
				</div>
			</CardBody>
		</Card>
	);
};

export default FormLoadingScreen;
